import {
  VAlert,
  VApp,
  VBtn,
  VCard,
  VContainer,
  VMain,
  VFooter,
  VHover,
  VNavigationDrawer,
  VSelect,
  VAppBar,
  VCardActions,
  VCardText,
  VCardTitle,
  VTextField,
  VTextarea,
  VCheckbox,
  VRadioGroup,
  VRadio,
  VImg,
  VIcon,
  VSimpleTable,
  VDatePicker,
  VLayout,
  VRow,
  VCol,
} from 'vuetify/lib'

export default {
  VAlert,
  VApp,
  VBtn,
  VCard,
  VContainer,
  VMain,
  VFooter,
  VHover,
  VNavigationDrawer,
  VSelect,
  VAppBar,
  VCardActions,
  VCardText,
  VCardTitle,
  VTextField,
  VTextarea,
  VCheckbox,
  VRadioGroup,
  VRadio,
  VImg,
  VIcon,
  VSimpleTable,
  VDatePicker,
  VLayout,
  VRow,
  VCol,
}

// ToDo: Dont’t include all
// import * as allComponents from 'vuetify/lib/components'

// export default {
//   ...allComponents,
// }
